import React, { ReactNode } from "react";
import { ICarrierCustomization, IAppState } from "../../state/interfaces";
import { Form, Alert, Card } from 'react-bootstrap'
import { connect } from "react-redux";
import { ValidatableForm } from "../../components/ValidatableForm"
import { QUOTE_STEPS, COMPONENTS } from "../../AppConstants";
import { validationUtils } from "../../validation/Validation";
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import Utilities from "../../classes/Utilities";
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteApiClient, IPaths } from "../../classes/Domain";
import QuoteActions from "../../state/appActions";
import queryString from 'query-string';
import { QuickQuoteStep } from "../QuickQuote/QuickQuoteStepLayout";


interface IUpdateAppState {
    program: string,
    zipCode: string
}

interface IState extends IQuoteStepState {
    zipCode: string,
    stateCode: string;
}

export interface IProps extends IQuoteStepComponentProps {
    zipCode?: string,
    nextPageUrl?: string,
    header?: ReactNode | null,
    program: string,
    initState: string,
    carrierCustomization?: ICarrierCustomization | null,
    resetAppState: () => void,
    setCarrierCustomization: (customization: ICarrierCustomization | null | undefined) => void,
    updateAppState: (update: IUpdateAppState) => Promise<any>,
    quoteApiClient: IQuoteApiClient;
    PATHS: IPaths;
}

class QuickZip extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);

        this.state = {
            zipCode: "",
            stateCode: "",
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        this.props.resetAppState();
        this.props.reportCurrentStep();
        this.props.setCarrierCustomization(this.props.carrierCustomization);

        validationUtils.subscribeToValidationFailure(QUOTE_STEPS.QUICK_ZIP,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(QUOTE_STEPS.QUICK_ZIP);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const _zipCode = nextProps.zipCode;
            nextProps.meta.propsSource = "";

            if (!_zipCode) return prevState;

            return {
                ...prevState,
                zipCode: _zipCode
            };
        }

        return prevState;
    }

    next(e: any) {
        e.preventDefault();
        this.setState({ updatingStore: true }, () => {

            this.props.updateAppState({ program: this.props.program, zipCode: this.state.zipCode })
                .then((result) => {
                    this.props.history.push(Utilities.formatUrl(this.props.nextPageUrl ?? this.props.PATHS.QUICK_VEHICLE, ""));
                },
                    () => {
                        //console.log("start quote page reject");
                        this.setState({ ...this.state, updatingStore: false });
                    }
                );
        });
    }

    onZipChange(e: any) {
        this.setState({ ...this.state, zipCode: e.target.value });
    }

    render() {
        return (
            <div className="quick-zip-step">
                <QuickQuoteStep id={this.props.id} >
                    <div>
                        <Card className="quick-quote-data" style={{ border: 'none', background: 'transparent' }}>
                            <Card.Body style={{ padding: '20px 10px' }}>
                                <Card className="vehicles-card" style={{ border: 'none', background: 'transparent' }}>
                                    <Card.Body style={{ padding: 0 }}>

                                        <h1 className="zip-title">
                                            Welcome to Qualitas<br />Get Your Quick Auto Insurance Quote
                                        </h1>

                                        <ValidatableForm hasErrors={null != this.state.errors} onSubmit={this.next}>
                                            <div className="row" style={{ justifyContent: 'center', margin: 0 }}>

                                                <div className="compare-new-form" style={{ width: '100%', maxWidth: '420px', padding: 0 }}>
                                                    {this.state.updatingStore
                                                        ?
                                                        <Alert variant={"warning"}>
                                                            Verifying zip. Please wait...
                                                        </Alert>
                                                        : null
                                                    }

                                                    <div className="form-group mb-3">
                                                        <Form.Control
                                                            onChange={(e) => this.onZipChange(e)}
                                                            placeholder="Your Zip"
                                                            value={this.state.zipCode}
                                                            disabled={this.state.updatingStore}
                                                            maxLength={5}
                                                            pattern="[0-9]*"
                                                            inputMode="numeric"
                                                            className="zip-input"
                                                        />
                                                        {null !== this.state.errors && validationUtils.getValidationErrorFor(this.state.errors, "zipCode")
                                                            ? <Form.Control.Feedback type="invalid">
                                                                {validationUtils.getValidationErrorFor(this.state.errors, "zipCode")}
                                                            </Form.Control.Feedback>
                                                            : null
                                                        }
                                                    </div>

                                                    <ButtonContinue
                                                        disabled={!this.state.zipCode || this.state.updatingStore}
                                                        showLoading={this.state.updatingStore}
                                                        label="Continue"
                                                        onClick={this.next}
                                                        className="zip-button"
                                                    />

                                                    <div className="trust-section">

                                                        <div className="trust-item-centered">
                                                            <div className="trust-content-wrapper">
                                                                <span className="trust-icon">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                                                                        <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
                                                                    </svg>
                                                                </span>
                                                                <p className="trust-text">
                                                                    Your information is secure, private and <span className="highlight-green">never sold.</span>
                                                                </p>
                                                            </div>
                                                            <div className="sub-trust-text-centered">No spam. No pressure.</div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                        </ValidatableForm>
                                    </Card.Body>
                                </Card>
                            </Card.Body>
                        </Card>
                    </div>
                </QuickQuoteStep>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    var searchParams = queryString.parse(ownProps.location.search);

    return {
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        zipCode: searchParams?.zipCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        resetAppState: () => dispatch(quoteActions.resetAppState()),
        setCarrierCustomization: (customization: ICarrierCustomization | null) => dispatch(quoteActions.setCarrierCustomization(customization)),
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.QUICK_ZIP)),
        updateAppState: (update: IUpdateAppState) => dispatch(quoteActions.startQuote(update.program, update.zipCode))
    };
};

export default connect(mapProps, mapDispatch)(QuickZip);